import message from "antd/es/message";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { auth, db } from "~/lib";
import { createTenant } from "~/graphql/mutations";
import { API } from "aws-amplify";
import i18n from "~/i18n";

export const addUser = async (payload: any) => {
  try {
    // Check if the username is unique
    const isUnique = await checkUsernameUniqueness(payload.username);
    if (!isUnique) {
      throw new Error(i18n.t("Username_already_exist"));
    }

    // Create user with email and password
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      payload.email,
      payload.password
    );
    const user = userCredential.user;

    const newTenant: any = await API.graphql({
      query: createTenant,
      variables: {
        input: {
          id: user.uid,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          authUID: user.uid,
        },
      },
    });

    // Make object with user data
    const userObject = {
      uid: user.uid,
      email: user.email,
      username: payload.username,
      firstName: payload.firstName,
      lastName: payload.lastName,
      tenantId: newTenant.data.createTenant.id,
    };

    const usernameRef = collection(db, "users");
    const userRef = await addDoc(usernameRef, userObject);
    return {
      success: true,
      data: userRef,
    };
  } catch (error: any) {
    message.error(error.message);
    console.error("add new user", error);
    return {
      success: false,
      data: {},
      error,
    };
  }
};

export const addGoogleUser = async (user: any) => {
  const isUnique = await checkUsernameUniqueness(user.email);
  // If it is not unique, it must be a signin not signup, so no need to add a new tenant or user info entry
  if (isUnique) {
    const newTenant: any = await API.graphql({
      query: createTenant,
      variables: {
        input: {
          id: user.uid,
          email: user.email,
          firstName: user.displayName,
          lastName: "",
        },
      },
    });

    // Add additional user info to Firestore (e.g., username)
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      email: user.email,
      username: user.email,
      firstName: user.displayName,
      tenantId: newTenant.data.createTenant.id,
    });

    if (auth.currentUser) await sendEmailVerification(auth.currentUser);
  }
};

const checkUsernameUniqueness = async (username: string) => {
  const usersCollection = collection(db, "users");
  const q = query(usersCollection, where("username", "==", username));

  const querySnapshot = await getDocs(q);

  if (querySnapshot.size > 0) {
    // Username already exists in the collection
    return false;
  }
  // Username is unique
  return true;
};
